import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { HandCoins, Send } from "lucide-react";
import { toast } from "sonner";
import { api, formatErr } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export function OfferDialog({ listing }) {
  const { user } = useAuth();
  const nav = useNavigate();
  const [amount, setAmount] = useState("");
  const [busy, setBusy] = useState(false);
  const quick = [0.9, 0.8].map((f) => Math.max(1, Math.round(listing.price * f)));

  const submit = async (e) => {
    e.preventDefault();
    if (!user) return nav(`/login?next=/listing/${listing.id}`);
    setBusy(true);
    try {
      const { data } = await api.post(`/listings/${listing.id}/offer`, { amount: Number(amount) });
      toast.success("Offer sent to the seller");
      nav(`/messages/${data.conversation_id}`);
    } catch (e2) { toast.error(formatErr(e2)); } finally { setBusy(false); }
  };

  return (
    <form data-testid="offer-box" onSubmit={submit} className="space-y-3 rounded-2xl border border-[#d4f253]/40 bg-[#0f2a33] p-4">
      <p className="flex items-center gap-2 text-sm font-bold"><HandCoins className="h-4 w-4 text-[#d4f253]" />Make an offer</p>
      <p className="text-xs text-slate-400">Asking ${listing.price.toLocaleString()}. Enter your price and we'll send it to the seller. If they accept, you pay in person at pick-up.</p>
      <div className="flex gap-2">
        {quick.map((q, i) => <button type="button" key={q} data-testid={`offer-quick-${i}`} onClick={() => setAmount(String(q))} className="rounded-full bg-white/10 px-3 py-1.5 text-xs font-semibold hover:bg-white/15">${q.toLocaleString()}</button>)}
      </div>
      <div className="flex gap-2">
        <div className="relative flex-1">
          <span className="absolute left-4 top-1/2 -translate-y-1/2 font-bold text-[#0f2a33]">$</span>
          <input data-testid="offer-amount-input" type="number" min="1" step="1" required value={amount} onChange={(e) => setAmount(e.target.value)} placeholder="Your offer" className="field !pl-9" />
        </div>
        <button data-testid="detail-make-offer-btn" disabled={busy || !(Number(amount) > 0)} className="btn-lime shrink-0 px-4 text-sm"><Send className="h-4 w-4" />{busy ? "Sending…" : user ? "Send offer" : "Log in to offer"}</button>
      </div>
    </form>
  );
}
